var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 1.21a.996.996 0 0 0-1.41 0L7 6.09 2.11 1.2A.996.996 0 1 0 .7 2.61L5.59 7.5.7 12.39a.996.996 0 1 0 1.41 1.41L7 8.91l4.89 4.89a.996.996 0 1 0 1.41-1.41L8.41 7.5l4.89-4.89c.38-.38.38-1.02 0-1.4"
  })));
};
export default SvgCross;